import React from 'react';

import Card from '../../../../../components/Card/index';
import FinalSummaryTable from '../Steps/Components/FinalSummaryTable';

const FinalApproval = ({ user, registration }) => {
  return (
    <Card>
      <Card.Header>Information Submitted</Card.Header>
      <Card.Body>
        <h2>
          Your final certification packet is currently under review. After Sage Financial Solutions approves your information, we'll notify
          you of your certification!
        </h2>
        <FinalSummaryTable user={user} registration={registration} />
      </Card.Body>
    </Card>
  );
};

export default FinalApproval;
